import { render, staticRenderFns } from "./clientProfileEdd.vue?vue&type=template&id=31c9e1ba&scoped=true"
import script from "./clientProfileEdd.vue?vue&type=script&lang=js"
export * from "./clientProfileEdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c9e1ba",
  null
  
)

export default component.exports